const defaultContext: any = {
  history: undefined,
  loading: undefined,
  experiment: undefined,
  urlData: {
    orderId: '',
    productId: '',
    deliveryId: '',
    skuId: '',
  },
  product: undefined,
  productId: '',
  mutation: {},
  forbidden: undefined,
  submitStatus: undefined,
  verifiedPurchase: undefined,
  productFormData: {
    withoutTrouble: undefined,
    deliveryId: '',
    skuId: '',
    rating: 0,
    tags: [],
    text: '',
    title: '',
    trouble: {
      type: '',
      description: '',
    },
  },
};

export default defaultContext;
export { defaultContext };
